import script from "./blackadd.vue?vue&type=script&setup=true&lang=js"
export * from "./blackadd.vue?vue&type=script&setup=true&lang=js"

import "./blackadd.vue?vue&type=style&index=0&id=5e8dd01a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8dd01a"]])

export default __exports__